module.exports = __webpack_public_path__ + "static/bannerNovo3-2828a939226a4b0c1effee0e069439c8.jpg";